import CostFieldProto from "./cost-proto";

export default class CostExpensesField extends CostFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.COST_EXPENSES;
        this.formulaCompatible = true;
    }

    static getValue(item) {
        return item.expensesCollection?.total || item.expenses;
    }

    get sortHintMessage() {
        return 'Sort by Expenses';
    }

    getCsvValue(item) {
        return CostExpensesField.getValue(item);
    }

    getValue(item) {return CostExpensesField.getValue(item)}

    listItemSortFunctions(sort) {
        return {
            functions: [i => CostExpensesField.getValue(i.item) || 0],
            directions: [sort]
        }
    }
}